import { render, staticRenderFns } from "./myContent.vue?vue&type=template&id=2a3a1a20&scoped=true"
import script from "./myContent.vue?vue&type=script&lang=js"
export * from "./myContent.vue?vue&type=script&lang=js"
import style0 from "./myContent.vue?vue&type=style&index=0&id=2a3a1a20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3a1a20",
  null
  
)

export default component.exports